<template>
    <div class="price-filter">
        <div class="input-group">
            <label for="price-from">{{ priceFrom }}</label>
            <input type="number"
                    id="price-from"
                    class="filter-input"
                    v-model="inputMin"
                    @input="handleChange"
                    min="0"
            >
        </div>
        <div class="input-group">
            <label for="price-to">{{ priceTo }}</label>
            <input type="number"
                   id="price-to"
                   class="filter-input"
                   v-model="inputMax"
                   @input="handleChange"
                   min="1"
            >
        </div>

        <input type="hidden" name="max" id="maxVal">
        <input type="hidden" name="min" id="minVal">
    </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'

import emitter from '../../utils/emitter'

export default {

    props: {
        sum: {
            required: true,
            type: Object
        },

        priceFrom: {
            required: false,
            type: String
        },

        priceTo: {
            required: false,
            type: String
        }
    },

    setup(props, {emit}) {

        const state = reactive({
            inputMin: props.sum.min,
            inputMax: props.sum.max,
        })

        onMounted( () => {

            emitter.on('setValuesFromParameters', ( {min, max} ) => {

                if ( min !== undefined && max !== undefined && min.length > 0 && max.length > 0 ) {
                    state.inputMin = min
                    state.inputMax = max
                }
            })
        })

        function handleChange() {

            if ( state.inputMax > props.sum.max )
                state.inputMax = props.sum.max

            document.getElementById('minVal').value = state.inputMin
            document.getElementById('maxVal').value = state.inputMax

            emit('onPriceChanged')
        }

        return {
            ...toRefs(state),
            handleChange
        }
    }
}
</script>



